import { Navigate, useLocation } from 'react-router-dom'

/** Os cadastros gerais moraram no Administrativo de 24/10 a 26/10/2026 e voltaram
 *  para a Logística a pedido do Samuel. O endereço antigo leva ao novo com o resto
 *  do caminho, a busca e a âncora. Fica fora do portão da área: quem não tem mais o
 *  Administrativo também chega. */
export function VoltouParaLogistica() {
  const { pathname, search, hash } = useLocation()
  return <Navigate to={`${pathname.replace(/^\/administrativo\//, '/logistica/')}${search}${hash}`} replace />
}

/** As Categorias fizeram o caminho contrário em 04/11/2026 (Samuel): da Logística
 *  para o Administrativo. O mesmo redirecionamento, com o resto do caminho, a busca
 *  e a âncora, fora do portão da área. */
export function FoiParaOAdministrativo() {
  const { pathname, search, hash } = useLocation()
  return <Navigate to={`${pathname.replace(/^\/logistica\//, '/administrativo/')}${search}${hash}`} replace />
}
